import { WalkthroughStep } from "../../../common/components/walkthroughV3/useWalkthrough";

export const notificationsSteps: WalkthroughStep[] = [
  {
    title: {
      en: "Notifications",
      tl: "Mga Abiso",
    },
    caption: {
      en: "This page shows all your notifications — security alerts, access changes, and system updates. Stay informed about important events affecting your account.",
      tl: "Ipinapakita ng pahinang ito ang lahat ng iyong mga abiso — mga alerto sa seguridad, mga pagbabago sa access, at mga update ng sistema. Manatiling may kaalaman tungkol sa mahahalagang kaganapan na nakakaapekto sa iyong account.",
    },
    highlights: [{ id: "notifications-menu" }],
    group: "Overview",
    captionPosition: "right",
  },
  {
    title: {
      en: "Notification Count",
      tl: "Bilang ng Abiso",
    },
    caption: {
      en: "The **red number** shows how many notifications are currently visible based on your active tab and search filter.",
      tl: "Ang **pulang numero** ay nagpapakita kung gaano karaming abiso ang kasalukuyang nakikita batay sa iyong aktibong tab at search filter.",
    },
    highlights: [{ id: "notifications-count" }],
    group: "Notifications",
    captionPosition: "bottom",
  },
  {
    title: {
      en: "Notification Tabs",
      tl: "Mga Tab ng Abiso",
    },
    caption: {
      en: "Use the **tabs** to switch between views.",
      tl: "Gamitin ang mga **tab** para lumipat sa pagitan ng mga view.",
    },
    highlights: [{ id: "notifications-tabs" }],
    group: "Notifications",
    isButtonOrSearchBar: true,
    captionPosition: "bottom",
    subCaption: [
      {
        title: {
          en: "Tab options:",
          tl: "Mga pagpipilian sa tab:",
        },
        subTitle: [
          {
            subTitle: {
              en: "**All** — View all notifications regardless of read status.",
              tl: "**All** — Tingnan ang lahat ng abiso anuman ang katayuan ng pagbabasa.",
            },
          },
          {
            subTitle: {
              en: "**Unread** — View only notifications you haven't read yet.",
              tl: "**Unread** — Tingnan lamang ang mga abisong hindi mo pa nabasa.",
            },
          },
          {
            subTitle: {
              en: "**Archive** — View notifications you've manually archived.",
              tl: "**Archive** — Tingnan ang mga abisong mano-manong na-archive mo.",
            },
          },
        ],
      },
    ],
  },
  {
    title: {
      en: "Notification List",
      tl: "Listahan ng Abiso",
    },
    caption: {
      en: "Notifications are grouped by date — **Today**, **Yesterday**, **Last Week**, and older. Click on any notification to see its full details. Unread notifications appear with a highlighted indicator.",
      tl: "Ang mga abiso ay nakagrupo ayon sa petsa — **Today**, **Yesterday**, **Last Week**, at mas luma pa. I-click ang anumang abiso para makita ang buong detalye nito. Ang mga hindi pa nababasa na abiso ay lumalabas na may naka-highlight na indicator.",
    },
    highlights: [{ id: "notifications-list" }],
    group: "Notifications",
    captionPosition: "top",
  },
  {
    title: {
      en: "Search",
      tl: "Paghahanap",
    },
    caption: {
      en: "Use the **search bar** to find a specific notification by keyword. Press **Enter** or click the magnifying glass to filter.",
      tl: "Gamitin ang **search bar** para mahanap ang isang partikular na abiso ayon sa keyword. Pindutin ang **Enter** o i-click ang magnifying glass para mag-filter.",
    },
    highlights: [{ id: "notifications-search-bar" }],
    group: "Page Tools",
    isButtonOrSearchBar: true,
  },
  {
    title: {
      en: "Mark All as Read / Unread",
      tl: "Markahan Lahat bilang Nabasa / Hindi Nabasa",
    },
    caption: {
      en: "Click this button to **mark all visible notifications** as read or unread at once. Useful for quickly clearing your unread count.",
      tl: "I-click ang button na ito para **markahan ang lahat ng nakikitang abiso** bilang nabasa o hindi nabasa nang sabay-sabay. Kapaki-pakinabang para mabilis na mapawi ang bilang ng hindi nabasa.",
    },
    highlights: [{ id: "mark-all-read-unread-button" }],
    group: "Page Tools",
    isButtonOrSearchBar: true,
    captionPosition: "bottom",
  },
  {
    title: {
      en: "Walkthrough Icon",
      tl: "Icon ng Walkthrough",
    },
    caption: {
      en: "Tip: If you accidentally close this walkthrough, just click the **💡 icon** anytime to start it again from the beginning.",
      tl: "Tip: Kung aksidenteng nasara ang walkthrough, i-click lang ang **💡 icon** anumang oras upang simulan ito muli mula sa simula.",
    },
    highlights: [{ id: "notifications-walkthrough-start-button" }],
    group: "Tips",
    captionPosition: "left",
    isButtonOrSearchBar: true,
  },
];
